<app-checkbox
    i18n
    *ngIf="enabledActions[SupervisorAction.ChangeShoe]"
    [disabled]="hasSecurityDoorsOpen || appPhase === AppPhase.WaitingForCroupier || appPhase === AppPhase.ShoeChange"
    [checked]="flagsState.changeShoeRequested ?? false"
    (changed)="actionClicked.emit(SupervisorAction.ChangeShoe)"
>
    Change shoe
</app-checkbox>

<button
    i18n
    *ngIf="enabledActions[SupervisorAction.VoidGame]"
    [disabled]="hasSecurityDoorsOpen || appPhase === AppPhase.WaitingForCroupier || appPhase === AppPhase.ShoeChange"
    class="button button-big-inline-padding button-neutral"
    (click)="actionClicked.emit(SupervisorAction.VoidGame)"
>
    Void game
</button>

<button
    i18n
    *ngIf="enabledActions[SupervisorAction.FreeHand]"
    [disabled]="
        hasSecurityDoorsOpen ||
        flagsState.freeHandEnabled ||
        appPhase === AppPhase.WaitingForCroupier ||
        appPhase === AppPhase.ShoeChange ||
        appPhase === AppPhase.RoundEnd
    "
    class="button button-big-inline-padding button-neutral"
    (click)="actionClicked.emit(SupervisorAction.FreeHand)"
>
    Free hand
</button>

<button
    i18n
    *ngIf="enabledActions[SupervisorAction.ChangeResult]"
    [disabled]="hasSecurityDoorsOpen || appPhase !== AppPhase.DealingCards"
    class="button button-big-inline-padding"
    (click)="actionClicked.emit(SupervisorAction.ChangeResult)"
>
    Change result
</button>

<button
    i18n
    *ngIf="enabledActions[SupervisorAction.CloseTable]"
    [disabled]="flagsState.tableClosingRequested"
    class="button button-big-inline-padding button-danger"
    [class.button-highlight]="flagsState.tableClosingRequested"
    (click)="actionClicked.emit(SupervisorAction.CloseTable)"
>
    Close table
</button>

<button
    i18n
    *ngIf="enabledActions[SupervisorAction.ChangeGame]"
    [disabled]="hasSecurityDoorsOpen || appPhase === AppPhase.ShoeChange"
    class="button button-big-inline-padding button-warning"
    (click)="actionClicked.emit(SupervisorAction.ChangeGame)"
>
    Change game
</button>

<button
    i18n
    *ngIf="enabledActions[SupervisorAction.ContinueGame]"
    [disabled]="hasSecurityDoorsOpen"
    class="button button-big-inline-padding button-accent"
    (click)="actionClicked.emit(SupervisorAction.ContinueGame)"
>
    Continue Game
</button>
